var map = {
	"./ga1.png": 462,
	"./gold_apple.png": 1458,
	"./letoile.png": 5238,
	"./letu.png": 300,
	"./letu.svg": 1670,
	"./ozon.png": 6308,
	"./ozon.svg": 6078,
	"./wb.svg": 1026,
	"./wildberries.png": 9194,
	"./ya_market.png": 6513
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 970;